import React from "react";
import Modal from "react-bootstrap/Modal";
import styles from "../Patient/Patient.module.scss";
import { Row, Col, Container } from "react-bootstrap";
import { FaLocationDot } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import patientMaleImage from "../../../images/CCImages/PatientImageMale.png"
import patientFemaleImage from "../../../images/CCImages/PatientImageFeMale.png"
const ViewModal = ({ viewModal, setViewModal, patientData }) => {
  return (
    <>
      <Modal
        show={viewModal}
        onHide={() => setViewModal(false)}
        size={"xl"}
        className={styles["modal"]}
      >
        <Modal.Header closeButton className={styles["modal-header"]}>
          <Modal.Title className={styles["modal-title"]}>
            Patient Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles["modal-body"]}>
          <Container className={styles["patient-container"]}>
            <Row className={styles["patient-row"]}>
              <Col lg={8} className={styles["patient-col"]}>
                <div className="profile">
                  <div className="staff">
                    {
                      patientData?.patient_image ? (
                        <img
                          src={patientData?.patient_image}
                          alt="PatientImage"
                          className="w-100"
                        />
                      ) : (
                        <img
                          src={patientData?.gender === "Female" ? patientFemaleImage : patientMaleImage}
                          alt="PatientImage"
                          className="w-100"
                        />
                      )
                    }
                  </div>
                  <div className="staf-info">
                    <div>
                      <span className="font-w600">Name:</span>
                      <h2 className="fs-18">{patientData?.name}</h2>
                      <div>
                        <span className="font-w600">Date Of Birth:</span>
                        <span className="fs-14">
                          {patientData?.dob ? new Date(patientData?.dob).toISOString().split('T')[0] : ""}
                        </span>
                      </div>
                      <span className="font-w600">Age:</span>
                      <span className="fs-17">{patientData?.age?.year} Y</span>
                      <div>
                        <span className="font-w600">Gender:</span>
                        <span className="fs-17">{patientData?.gender}</span>
                      </div>
                    </div>
                    <div className="location mt-2">
                      <div>
                        <span>
                          <FaLocationDot className="me-1 mb-1" />
                          {patientData?.userId?.address ? (
                            <>
                              {patientData?.userId?.address},
                              {patientData?.userId?.pin &&
                                `${patientData?.userId?.pin},`}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </span>
                      </div>
                      <div className="mt-2">
                        <span>
                          <IoCall />
                          +91 {patientData?.phone}
                        </span>
                        <span>
                          <IoMdMail className="me-1" />
                          {patientData?.email}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="d-flex justify-content-between  mb-3">
                  <span className="font-w600 text-black">Blood Group</span>
                  <span>{patientData?.blood_group}</span>
                </div>
                <div className="d-flex justify-content-between  mb-3">
                  <span className="font-w600 text-black">HC Number</span>
                  <span>{patientData?.HC_number}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="font-w600 text-black">Passport</span>
                  <span>{patientData?.passport}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="font-w600 text-black">Adhar No.</span>
                  <span>{patientData?.aadhar_number}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="font-w600 text-black">Membership Group</span>
                  <span>{patientData?.membership_group}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="font-w600 text-black">Abha Number</span>
                  <span>{patientData?.userId?.abhaNumber}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="font-w600 text-black">Abha Address</span>
                  <span>{patientData?.userId?.abhaAddress}</span>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewModal;
